import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';
import React from 'react';
import {
  Button,
  Form,
  Input,
  ModalFooter,
  SizeFittingTable,
} from 'src/components/Antd';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import ModalHoc from 'src/constrains/ModalHOC';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { isNumber } from 'src/tools/helper';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;

const AttributesTable = ModalHoc((props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { value, onChange, id, modalOp, disableEdit } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp || {};
  const [att, setAtt] = React.useState(value || []);
  //const [selected, setSelected] = React.useState(null);
  React.useEffect(() => {
    if (value !== att) {
      setAtt(value || []);
    }
  }, [value]);
  const handleOnChange = (att) => {
    if (onChange) {
      onChange(att);
    }
  };
  const handleOnClose = () => {
    onModalCancel();
    //setSelected(null);
  };

  const handleOnEditFinish = ({ data, index }) => {
    const _att = [...att];

    if (isNumber(index)) {
      _att.splice(index, 1, data);
    } else {
      const _data = { _uuid: Date.now(), ...data };
      _att.push(_data);
    }

    setAtt(_att);
    handleOnChange(_att);
    handleOnClose();
  };
  const handleOnDelete = (index) => {
    const _att = [...att];
    _att.splice(index, 1);
    setAtt(_att);
    handleOnChange(_att);
  };
  const handleOnEdit = (index, att) => {
    setModalContent(
      <AttEditor
        data={att}
        index={index}
        onCancel={handleOnClose}
        onConfirm={handleOnEditFinish}
      />,
    );
    setModalTitle(getI18n('general.editAttributes'));
    setShowModal(true);
    // setSelected(att);
  };
  return (
    <div className={css.tableContainer} id={id}>
      <SizeFittingTable
        // rowKey='name'
        id='SalesChannelDiscountAttributesTable'
        dataSource={att}
        pagination={false}
        columns={col(handleOnDelete, handleOnEdit, disableEdit, { getI18n })}
        rowKey={(record) => {
          const { uuid, _uuid, name } = record;
          if (uuid) {
            return uuid;
          }
          return _uuid || name;
        }}
      />
      <Button
        onClick={() => {
          setModalContent(
            <AttEditor
              data={null}
              onCancel={handleOnClose}
              onConfirm={handleOnEditFinish}
            />,
          );
          setModalTitle(getI18n('general.addAttributes'));
          setShowModal(true);
        }}
        className={css.addBtn}
        disabled={disableEdit}>
        {getI18n('general.addAttributes')}
      </Button>
    </div>
  );
});

export default AttributesTable;

const col = (onDelete, onEdit, disableEdit, { getI18n }) => {
  return [
    {
      minWidth: 300,
      title: getI18n('general.attributeName'),
      key: 'name',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'name');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },

    {
      minWidth: 300,
      title: getI18n('general.purpose'),
      key: 'purpose',
      default: true,
      childGenerate: (a, record, index) => {
        const purpose = get(record, 'purpose');
        return (
          <NoWrapContainer>
            <Tooltip title={purpose}>{purpose}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 230,
      title: getI18n('general.value'),
      key: 'value',
      default: true,
      childGenerate: (a, record, index) => {
        const value = get(record, 'value');
        return (
          <NoWrapContainer>
            <Tooltip title={value}>{value}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          key: 'Actions',
          default: true,
          childGenerate: (url, record, index) => {
            return (
              <Actions
                onDelete={() => {
                  if (onDelete) {
                    onDelete(index);
                  }
                }}
                onEdit={() => {
                  if (onEdit) {
                    onEdit(index, record);
                  }
                }}
              />
            );
          },
          width: 190,
        },
  ];
};
const AttEditor = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [form] = Form.useForm();
  const { data, onConfirm, onCancel, index } = props;
  const handleOnSubmit = (values) => {
    const v = { ...(data || {}), ...values };
    onConfirm({
      data: v,
      index,
    });
  };
  return (
    <React.Fragment>
      <div className={css.modalBody}>
        <Form form={form} initialValues={data} onFinish={handleOnSubmit}>
          <ItemWrapper title={`${getI18n('general.attributeName')}*`}>
            <Item
              name={'name'}
              rules={[
                {
                  required: true,
                  message: getI18n('general.pleasefilltheattributename'),
                },
              ]}>
              <Input size='large' maxLength={100} />
            </Item>
          </ItemWrapper>
          <ItemWrapper title={`${getI18n('general.purpose')}*`}>
            <Item
              name={'purpose'}
              rules={[
                {
                  required: true,
                  message: getI18n('general.pleasefilltheattributepurpose'),
                },
              ]}>
              <Input size='large' maxLength={100} />
            </Item>
          </ItemWrapper>
          <ItemWrapper title={`${getI18n('general.value')}*`}>
            <Item
              name={'value'}
              rules={[
                {
                  required: true,
                  message: getI18n('general.pleasefilltheattributevalue'),
                },
              ]}>
              <Input size='large' maxLength={100} />
            </Item>
          </ItemWrapper>
        </Form>
      </div>
      <ModalFooter
        onCancel={onCancel}
        onOk={() => {
          form.submit();
        }}
      />
    </React.Fragment>
  );
};
